
import {
  ChakraProvider,
  Box,
} from "@chakra-ui/react"
import {Navbar} from './Navbar'
import {Homepage} from './Homepage'
import theme from './theme'
import { useState } from "react"



export const App = () => {

  const [showNavbar, setShowNavbar] = useState(false)

 
  
  return (

  <ChakraProvider theme={theme}>
    <Box textAlign="center" fontSize="xl" maxWidth="100%" overflow="hidden">
      <Navbar showNavbar={showNavbar} setShowNavbar={setShowNavbar}/>
      <Homepage showNavbar={showNavbar} setShowNavbar={setShowNavbar}/>
    </Box>
  </ChakraProvider>
)}
